var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { isDeliveryClosed } from '../../app/cart-logic';
import Trash from '../../icons/Trash';
import Shapes from 'Shapes';
import ordersConfigShape from 'App/app/shapes/orders-config';
import CartItem from 'Comps/Cart/CartItem';
import CartDiscount from 'Comps/Cart/CartDiscount';
import PoweredByOtoStolik from '../common/PoweredByOtoStolik';
import RestaurantMenuPageHours from '../Restaurant/RestaurantMenuPageHours';
import { getTodayDeliveryHours } from '../../app/date-helpers';
import { isDeliveryPossible, isTakeoutPossible } from '../../utils/restaurant';
import { isIframe } from '../../utils/url-params';
import OtoSpinner from 'Comps/common/OtoSpinner';
import CartSummary from './CartSummary';
import './cart.scss';
export function getCartItemKey(cartItem, index) {
    return "".concat(cartItem.name).concat(index).concat(cartItem.option || '').concat((cartItem.selectedAdditionalFields || []).join(' | '));
}
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isClosed: false };
        _this.isClosedInterval = null;
        _this.updateIsClosed = function () {
            var deliveryHours = getTodayDeliveryHours(_this.props.restaurantDetails.deliveryHours);
            var isClosed = isDeliveryClosed(deliveryHours);
            _this.setState({ isClosed: isClosed });
            if (isClosed) {
                _this.isClosedInterval && clearInterval(_this.isClosedInterval);
            }
        };
        _this.isCartEmpty = function () { return !_this.props.cart.length; };
        return _this;
    }
    Cart.prototype.componentDidMount = function () {
        this.isClosedInterval = setInterval(this.updateIsClosed, 1000);
    };
    Cart.prototype.componentWillUnmount = function () {
        this.isClosedInterval && clearInterval(this.isClosedInterval);
    };
    Cart.prototype.render = function () {
        var _this = this;
        var _a = this.props, basketLoading = _a.basketLoading, basketStatus = _a.basketStatus, cart = _a.cart, clearCart = _a.clearCart, disabledOrdersReason = _a.disabledOrdersReason, hasDisablingCRs = _a.hasDisablingCRs, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails, proceedToPayment = _a.proceedToPayment, isTakeoutMode = _a.isTakeoutMode;
        var deliveryHours = getTodayDeliveryHours(restaurantDetails.deliveryHours);
        if (basketLoading) {
            return React.createElement(OtoSpinner, { center: true });
        }
        if (this.isCartEmpty() || !basketStatus) {
            return (React.createElement("div", null, "Koszyk jest pusty. Dodaj co\u015B, zam\u00F3w online i ciesz si\u0119 jedzeniem w swoim domu!"));
        }
        var isClosed = this.state.isClosed;
        var showDeliveryError = !isDeliveryPossible(restaurantDetails) && !isTakeoutMode;
        var showTakeoutError = !isTakeoutPossible(restaurantDetails) && isTakeoutMode;
        var isDisabled = isClosed ||
            !!disabledOrdersReason ||
            hasDisablingCRs ||
            showDeliveryError ||
            showTakeoutError;
        return (React.createElement(React.Fragment, null,
            cart.map(function (cartItem, index) { return (React.createElement(CartItem, { key: getCartItemKey(cartItem, index), item: cartItem, onRemoveClick: function () { return _this.props.removeItem(index); } })); }),
            React.createElement(CartDiscount, { items: cart, restaurantDetails: restaurantDetails }),
            React.createElement("div", { className: "d-flex flex-column" },
                React.createElement(Button, { className: "clear-cart-btn align-self-end", color: "link", onClick: clearCart },
                    React.createElement("span", null, "Wyczy\u015B\u0107 koszyk"),
                    " ",
                    React.createElement(Trash, null)),
                React.createElement(CartSummary, { basketStatus: basketStatus, isTakeoutMode: isTakeoutMode, isEmpty: this.isCartEmpty(), restaurant: restaurant })),
            React.createElement(Button, { type: "button", disabled: isDisabled, className: "cart-order-btn", color: "primary", onClick: proceedToPayment },
                "Zamawiam z ",
                isTakeoutMode ? 'odbiorem' : 'dostawą'),
            isClosed && (React.createElement(RestaurantMenuPageHours, { restaurant: restaurant, hours: deliveryHours, options: { className: 'text-center text-danger' } })),
            disabledOrdersReason && (React.createElement("div", { className: "text-danger" }, disabledOrdersReason.text)),
            showTakeoutError && (React.createElement("div", { className: "text-danger text-center" }, "Odbi\u00F3r osobisty niemo\u017Cliwy")),
            showDeliveryError && (React.createElement("div", { className: "text-danger text-center" }, "Dostawa niemo\u017Cliwa")),
            isIframe() && React.createElement(PoweredByOtoStolik, null)));
    };
    Cart.displayName = 'Cart';
    Cart.propTypes = {
        basketStatus: Shapes.basketStatusShape,
        basketLoading: PropTypes.bool.isRequired,
        cart: PropTypes.array.isRequired,
        clearCart: PropTypes.func.isRequired,
        disabledOrdersReason: PropTypes.object,
        hasDisablingCRs: PropTypes.bool.isRequired,
        isTakeoutMode: PropTypes.bool.isRequired,
        restaurant: Shapes.restaurantShape.isRequired,
        restaurantDetails: ordersConfigShape.isRequired,
        proceedToPayment: PropTypes.func.isRequired,
        removeItem: PropTypes.func.isRequired,
    };
    return Cart;
}(React.PureComponent));
export default Cart;
